module.exports = __webpack_public_path__ + "8c1cc807b97d844f4e76a315996f2f2d.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/origo.svg
// module id = 414
// module chunks = 0